<section class="dimmed-background" (click)="handleBackdropClick($event)">
    <div class="overlay-kanban-edit" (click)="$event.stopPropagation() ;subtaskTest($event); closeEditingSubtaskOnOverlay($event)">
        <div class="close-button" (click)="boardService.toggleEditOverlay()">
            <img src="assets/img/add-contacts/Vector.svg"  alt="" />
        </div>
        <div class="overlay-content-wrapper">
            <div class="content-in-overlay">
                <form class="kanban-overlay-form">
                    <div class="form-title kanban-div">
                        <span>Title</span>
                        <input maxlength="30"  [(ngModel)]="task.title" name="taskTitle" placeholder="Enter a title" type="text">
                    </div>
                    <div class="form-description kanban-div">
                        <span>Description</span>
                        <textarea  [(ngModel)]="task.description" name="taskDescription" placeholder="Enter a Description " maxlength="120"></textarea>
                    </div>
                    <div class="form-date kanban-div">
                        <span>Due date</span>
                        <input #picker (click)="picker.showPicker()" type="date" [(ngModel)]="task.dueDate" name="taskDate" [min]="currentDate" onkeydown="return false;"/>
                    </div>
                </form>

                <div class="kanban-edit-overlay-priority">
                    <p>Priority</p>
                    <div class="prioity-buttons">

                        <button (click)="changeToUrgent()" [disabled]="task.priority === 'Urgent'"  [class.active-urgent]="task.priority === 'Urgent'">
                            <span>Urgent</span>
                            @if(task.priority !== 'Urgent'){
                                <img src="assets/img/kanban-edit-overlay/urgent-arrow.svg"alt=""/>
                            }@else {
                                <img src="assets/img/kanban-edit-overlay/white-urgent.svg"alt=""/>
                            }
                        </button>

                        <button (click)="changeToMedium()" [disabled]="task.priority === 'Medium'"   [class.active-medium]="task.priority === 'Medium'">
                            <span>Medium</span>
                            @if(task.priority !== 'Medium'){
                                <img src="assets/img/kanban-edit-overlay/medium-arrow.svg"alt=""/>
                            }@else {
                                <img src="assets/img/kanban-edit-overlay/white-medium.svg"alt=""/>
                            }
                        </button>

                        <button (click)="changeToLow()" [disabled]="task.priority === 'Low'" [class.active-low]="task.priority === 'Low'">
                            <span>Low</span>
                            @if(task.priority !== 'Low'){
                                <img src="assets/img/kanban-edit-overlay/low-arrow.svg" alt=""/>
                            }@else{
                                <img src="assets/img/kanban-edit-overlay/white-low.svg" alt=""/>
                            }
                        </button>

                    </div>
                </div>

                <div class="kanban-assigned-to">
                    <span class="assigned-span">Assigned to</span>
                    <div class="all-user-container">
                        <mat-select [(ngModel)]="task.assignedTo" panelClass="select-to-assign"  required name="name" id="" multiple>
                            @for (assigned of task.assignedTo; track $index) {
                                <mat-option id={{$index}} [value]="assigned" aria-checked="true">
                                    <div class="option-text"><div class="select-initials" [style.background]="assigned.color">{{assigned.initials}}</div> <div>{{assigned.firstName}} {{assigned.lastName}}</div></div>
                                </mat-option>
                            }
                            @for (user of overlayState.contactList; track $index) {
                                @if (!isUserAssigned(user)) {
                                <mat-option id={{$index}} [value]="user">
                                    <div class="option-text"><div class="select-initials" [style.background]="user.color">{{user.initials}}</div> <div>{{user.firstName}} {{user.lastName}}</div></div>
                                </mat-option>
                                }
                            } 
                        </mat-select>
                    </div>
                    <div class="already-assigned">
                        @for (assigned of task.assignedTo?.slice(0, 3) || [];; track $index) {
						<div id={{$index}} class="select-initials" [style.background]="assigned.color">
							{{assigned.initials}}
						</div>
						}
						@if ((task.assignedTo?.length || 0) > 3) {
						<div class="more-users">+{{ (task.assignedTo?.length || 0) - 3 }}</div>
						}
                    </div>
                </div>

                <div class="category-dropdown">
					<label class="form-label">Category</label>
					<select [(ngModel)]="task.category" panelClass="select-category" name="category" required
						#category="ngModel">
						<option value="Management">Management</option>
						<option value="Technical">Technical</option>
						<option value="Developement">Developement</option>
						<option value="Design">Design</option>
						<option value="Documentation">Documentation</option>
						<option value="User Story">User Story</option>
					</select>
				</div>

                <div class="kanban-overlay-subtask">
                    <span>Subtask</span>
                    <div class="subtaskfield" (click)="$event.stopPropagation();">
                        <input maxlength="30" (keydown)="onKeydown($event)" name="subtaskInput" [(ngModel)]="subtaskString" type="text" (focus)="isInputFocused = true" (blur)="handleBlur()">
                        @if(!isInputFocused){
                            <div class="add" (click)="setFocusOnInput()">
                                <img src="assets/img/kanban-edit-overlay/plus-zichen.svg" alt=""/>
                            </div>
                        }@else {
                            <div class="submit-cancel">
                                <button (click)="emptySubtask()">
                                    <img  src="assets/img/kanban-edit-overlay/exit-subtask.svg" alt="">
                                </button>
                                
                                <div class="grey-line"></div>
                                <button (click)="pushToSubtask()">
                                    <img  src="assets/img/kanban-edit-overlay/checkmark-subtask.svg" alt="">
                                </button>
                            </div>
                        }
                    </div>
                    <div class="each-sub-task">
                        @for (subtask of task.subTaskFillTest; track $index) {
                            @if (editingSubtaskIndex === $index) {
                                <li (click)="$event.stopPropagation()">
                                    <textarea [(ngModel)]="subtask.text" maxlength="30"></textarea>
                                    <button (click)="saveEditingSubtask($index); $event.stopPropagation()">
									    <img src="assets/img/kanban-add/checkmark-subtask.svg" alt="save">
                                    </button>
                                    <button (click)="spliceSubtask($index); $event.stopPropagation()">
                                        <img src="assets/img/kanban-add/subTaskDeleteButton.png" alt="delete">
                                    </button>
                                </li>
                            }@else {
                                <li (dblclick)="startEditingSubtask($index)">
                                    {{ subtask.text }}
                                </li>
                            }
                        }
                    </div>
                </div>
            </div>
            
            <div class="confirm-edit-button">
                <button (click)="confirmChanges(); boardService.toggleEditOverlay()">
                    <span>Ok</span>
                    <img src="assets/img/add-contacts/check.svg" alt="" />
                </button>
            </div>
        </div>
    </div>
</section>
